// @flow

// Libs
import _indexOf from 'lodash/indexOf'

// Exports
export default function createAsListDecoder<T> (options: Array<T>, maybeDefaultOption: ?T): (value: ?T) => ?T {
  const defaultOption = maybeDefaultOption != null
    ? maybeDefaultOption
    : null

  return function asListDecoder (value: ?T): ?T {
    if (value == null) {
      return defaultOption
    } else if (_indexOf(options, value) >= 0) {
      return value
    }

    return defaultOption
  }
}
